import MuiInputBase from '@mui/material/InputBase'
import { styled } from '@mui/material/styles'
import { colors, transitions } from 'styles/theme'

const InputBase = styled(MuiInputBase)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
  border: `1px solid ${colors.gray[300]}`,
  transition: `borderColor, ${transitions.sm}`,
  fontSize: 14,

  '&:hover:not(:focus-within):not(.Mui-disabled):not(.Mui-error)': {
    borderColor: colors.gray[700],
  },
  '&.Mui-error': {
    borderColor: colors.red[500],
  },
  '&:focus-within.Mui-error': {
    borderColor: colors.red[500],
  },

  '&.Mui-disabled': {
    borderColor: colors.gray[200],
    backgroundColor: colors.gray[50],
  },

  '&:focus-within': {
    borderColor: colors.accent,
  },
  '& .MuiInputBase-input': {
    padding: 12,
    '&:read-only': {
      color: colors.gray[700],
    },
  },
  'label + &': {
    marginTop: theme.spacing(3),
  },
  '& .MuiInputBase-inputAdornedStart': {
    paddingLeft: 0,
  },
  '&.MuiInputBase-adornedStart': {
    paddingLeft: 12,
  },
  '& .MuiInputBase-inputAdornedEnd': {
    paddingRight: 0,
  },
  '&.MuiInputBase-adornedEnd': {
    paddingRight: 12,
    whiteSpace: 'nowrap',
    color: colors.gray[700],
    '& .MuiInputBase-inputAdornedEnd': {
      color: colors.softBlack,
    },
  },
}))

export default InputBase
